var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Children, cloneElement } from 'react';
import styles from '../../@patternfly/patternfly-next/components/Dropdown/dropdown.css.js';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import DropdownMenu from './DropdownMenu';
import { DropdownPosition, DropdownDirection } from './dropdownConstants';

// seed for the aria-labelledby ID
var currentId = 0;

var propTypes = {
  /** Anything which can be rendered in a dropdown */
  children: function children(props) {
    if (props.dropdownItems && props.dropdownItems.length > 0 && props.children) {
      return new Error('Children and dropdownItems props have been provided. Only the dropdownItems prop items will be rendered ');
    }
    return null;
  },
  /** Classes applied to root element of dropdown */
  className: PropTypes.string,
  /** Array of DropdownItem nodes that will be rendered in the dropdown Menu list */
  dropdownItems: PropTypes.array,
  /** Flag to indicate if menu is opened */
  isOpen: PropTypes.bool,
  /** Display the toggle with no border or background */
  isPlain: PropTypes.bool,
  /** Indicates where menu will be alligned horizontally */
  position: PropTypes.oneOf(Object.keys(DropdownPosition)),
  /** Display menu above or below dropdown toggle */
  direction: PropTypes.oneOf(Object.keys(DropdownDirection)),
  /** Placeholder to use custom toggle elements */
  toggle: PropTypes.node.isRequired,
  /** Function callback called when user selects item */
  onSelect: PropTypes.func
};

var defaultProps = {
  children: null,
  className: '',
  dropdownItems: [],
  isOpen: false,
  isPlain: false,
  position: DropdownPosition.left,
  direction: DropdownDirection.down,
  onSelect: Function.prototype
};

var Dropdown = function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    _classCallCheck(this, Dropdown);

    return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
  }

  _createClass(Dropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          dropdownItems = _props.dropdownItems,
          isOpen = _props.isOpen,
          toggle = _props.toggle,
          direction = _props.direction,
          onSelect = _props.onSelect,
          isPlain = _props.isPlain,
          position = _props.position,
          props = _objectWithoutProperties(_props, ['className', 'children', 'dropdownItems', 'isOpen', 'toggle', 'direction', 'onSelect', 'isPlain', 'position']);

      var id = toggle.props.id || 'pf-toggle-id-' + currentId++;
      var component = void 0;
      var renderedContent = void 0;
      if (dropdownItems && dropdownItems.length > 0) {
        component = 'ul';
        renderedContent = dropdownItems;
      } else {
        component = 'div';
        renderedContent = children;
      }
      return React.createElement(
        'div',
        _extends({}, props, {
          className: css(styles.dropdown, isPlain && styles.modifiers.plain, direction === DropdownDirection.up && styles.modifiers.top, isOpen && styles.modifiers.expanded, className),
          ref: function ref(_ref) {
            _this2.parentRef = _ref;
          }
        }),
        Children.map(toggle, function (oneToggle) {
          return cloneElement(oneToggle, { parentRef: _this2.parentRef, isOpen: isOpen, id: id });
        }),
        isOpen && React.createElement(
          DropdownMenu,
          {
            component: component,
            isOpen: isOpen,
            position: position,
            'aria-labelledby': id,
            onClick: function onClick(event) {
              return onSelect && onSelect(event);
            }
          },
          renderedContent
        )
      );
    }
  }]);

  return Dropdown;
}(React.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Dropdown/Dropdown.js
// module id = 228
// module chunks = 0